// Инициализация кастомных селектов
function initCustomSelects() {
    // Инициализируем только селекты в формах бронирования
    const customSelects = document.querySelectorAll('.shopping .custom-select, .shopping-form .custom-select');

    customSelects.forEach(select => {
        const trigger = select.querySelector('.custom-select__trigger');
        const options = select.querySelector('.custom-select__options');
        const optionItems = select.querySelectorAll('.custom-select__option');
        const hiddenInput = select.querySelector('input[type="hidden"]');
        const valueSpan = select.querySelector('.custom-select__value');

        // Проверяем, что все необходимые элементы существуют
        if (!trigger || !options) {
            return;
        }

        // Проверяем, что селект еще не инициализирован
        if (select.dataset.initialized === 'true') {
            return;
        }

        // Отмечаем селект как инициализированный
        select.dataset.initialized = 'true';

        // Обработчик клика по триггеру
        trigger.addEventListener('click', (e) => {
            e.stopPropagation();

            // Закрываем все другие селекты
            customSelects.forEach(otherSelect => {
                if (otherSelect !== select) {
                    otherSelect.classList.remove('active');
                }
            });

            // Переключаем текущий селект
            select.classList.toggle('active');
        });

        // Обработчики клика по опциям
        optionItems.forEach(option => {
            option.addEventListener('click', (e) => {
                e.stopPropagation();

                const value = option.getAttribute('data-value');
                const text = option.textContent;

                // Обновляем скрытое поле
                if (hiddenInput) {
                    hiddenInput.value = value;
                }

                // Обновляем отображаемый текст
                if (valueSpan) {
                    valueSpan.textContent = text;
                }

                // Закрываем селект
                select.classList.remove('active');

                // Триггерим событие change для совместимости
                if (hiddenInput) {
                    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });
    });

    // Закрытие селектов при клике вне их
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.shopping .custom-select, .shopping-form .custom-select')) {
            customSelects.forEach(select => {
                select.classList.remove('active');
            });
        }
    });

    // Закрытие селектов при нажатии Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            customSelects.forEach(select => {
                select.classList.remove('active');
            });
        }
    });
}

// Функция для добавления новой опции в кастомный селект
function addCustomSelectOption(selectElement, value, text, isSelected = false) {
    const optionsContainer = selectElement.querySelector('.custom-select__options');

    if (!optionsContainer) {
        return false;
    }

    // Создаем новую опцию
    const newOption = document.createElement('div');
    newOption.className = 'custom-select__option';
    newOption.setAttribute('data-value', value);
    newOption.textContent = text;

    // Добавляем обработчик клика
    newOption.addEventListener('click', (e) => {
        e.stopPropagation();

        const hiddenInput = selectElement.querySelector('input[type="hidden"]');
        const valueSpan = selectElement.querySelector('.custom-select__value');

        // Обновляем скрытое поле
        if (hiddenInput) {
            hiddenInput.value = value;
        }

        // Обновляем отображаемый текст
        if (valueSpan) {
            valueSpan.textContent = text;
        }

        // Закрываем селект
        selectElement.classList.remove('active');

        // Триггерим событие change для совместимости
        if (hiddenInput) {
            hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });

    // Добавляем опцию в контейнер
    optionsContainer.appendChild(newOption);

    // Если это выбранная опция, устанавливаем её как активную
    if (isSelected) {
        const valueSpan = selectElement.querySelector('.custom-select__value');
        const hiddenInput = selectElement.querySelector('input[type="hidden"]');

        if (valueSpan) {
            valueSpan.textContent = text;
        }
        if (hiddenInput) {
            hiddenInput.value = value;
        }
    }

    return newOption;
}

// Функция для удаления опции из кастомного селекта
function removeCustomSelectOption(selectElement, value) {
    const optionToRemove = selectElement.querySelector(`.custom-select__option[data-value="${value}"]`);

    if (optionToRemove) {
        optionToRemove.remove();
        return true;
    }

    return false;
}

// Функция для очистки всех опций в кастомном селекте
function clearCustomSelectOptions(selectElement) {
    const optionsContainer = selectElement.querySelector('.custom-select__options');

    if (optionsContainer) {
        optionsContainer.innerHTML = '';

        // Сбрасываем выбранное значение
        const valueSpan = selectElement.querySelector('.custom-select__value');
        const hiddenInput = selectElement.querySelector('input[type="hidden"]');

        if (valueSpan) {
            // Устанавливаем плейсхолдер в зависимости от типа селекта
            const selectType = selectElement.getAttribute('data-select');
            if (selectType === 'stylist') {
                valueSpan.textContent = 'Выберите стилиста';
            } else if (selectType === 'time') {
                valueSpan.textContent = 'Выберите время';
            } else {
                valueSpan.textContent = 'Выберите опцию';
            }
        }
        if (hiddenInput) {
            hiddenInput.value = '';
        }

        return true;
    }

    return false;
}

// Функция для получения всех опций кастомного селекта
function getCustomSelectOptions(selectElement) {
    const options = selectElement.querySelectorAll('.custom-select__option');
    const optionsArray = [];

    options.forEach(option => {
        optionsArray.push({
            value: option.getAttribute('data-value'),
            text: option.textContent
        });
    });

    return optionsArray;
}

// Функция для получения выбранного значения кастомного селекта
function getCustomSelectValue(selectElement) {
    const hiddenInput = selectElement.querySelector('input[type="hidden"]');
    return hiddenInput ? hiddenInput.value : '';
}

// Функция для установки выбранного значения кастомного селекта
function setCustomSelectValue(selectElement, value) {
    const option = selectElement.querySelector(`.custom-select__option[data-value="${value}"]`);

    if (option) {
        const text = option.textContent;
        const hiddenInput = selectElement.querySelector('input[type="hidden"]');
        const valueSpan = selectElement.querySelector('.custom-select__value');

        if (hiddenInput) {
            hiddenInput.value = value;
        }
        if (valueSpan) {
            valueSpan.textContent = text;
        }

        return true;
    }

    return false;
}

// Функция для массового добавления опций
function addCustomSelectOptions(selectElement, optionsArray) {
    if (!Array.isArray(optionsArray)) {
        return false;
    }

    optionsArray.forEach(option => {
        if (option.value && option.text) {
            addCustomSelectOption(selectElement, option.value, option.text, option.selected || false);
        }
    });

    return true;
}

// Функция для обновления фотографии стилиста
function updateStylistPhoto(stylistId) {

    const photoElement = document.getElementById('stylist-photo');
    if (!photoElement) {
        return;
    }

    // Если стилист не выбран, показываем фото по умолчанию
    if (!stylistId) {
        const defaultPhoto = '/wp-content/themes/planetalook/assets/images/teststylist.png';
        photoElement.src = defaultPhoto;
        photoElement.alt = 'Фотография стилиста';
        return;
    }

    // Ищем данные стилиста
    if (!window.stylistsData || !window.stylistsData.results) {

        return;
    }

    const stylist = window.stylistsData.results.find(s => s.id == stylistId);
    if (!stylist) {

        return;
    }

    // Получаем фотографию из options.photo и обрабатываем разные форматы
    let photoUrl = '/wp-content/themes/planetalook/assets/images/teststylist.png'; // По умолчанию

    if (stylist.options && stylist.options.photo) {
        const photo = stylist.options.photo;


        if (typeof photo === 'string') {
            // Если это строка
            if (photo.startsWith('http')) {
                photoUrl = photo;
            } else if (photo.startsWith('/')) {
                photoUrl = `https://ufa.planeta-mall.ru${photo}`;
            } else {
                photoUrl = `https://ufa.planeta-mall.ru/${photo}`;
            }
        } else if (typeof photo === 'object' && photo !== null) {
            // Если это объект, пытаемся извлечь URL
            if (photo.url) {
                if (photo.url.startsWith('http')) {
                    photoUrl = photo.url;
                } else if (photo.url.startsWith('/')) {
                    photoUrl = `https://ufa.planeta-mall.ru${photo.url}`;
                } else {
                    photoUrl = `https://ufa.planeta-mall.ru/${photo.url}`;
                }
            } else if (photo.src) {
                if (photo.src.startsWith('http')) {
                    photoUrl = photo.src;
                } else if (photo.src.startsWith('/')) {
                    photoUrl = `https://ufa.planeta-mall.ru${photo.src}`;
                } else {
                    photoUrl = `https://ufa.planeta-mall.ru/${photo.src}`;
                }
            } else {

                photoUrl = 'https://ufa.planeta-mall.ru/wp-content/themes/planetalook/assets/images/teststylist.png';
            }
        }
    }


    photoElement.src = photoUrl;
    photoElement.alt = `Фотография стилиста ${stylist.title}`;
}

// Функция для заполнения селекта стилистов данными из API
function populateStylistSelect(stylists) {


    if (!stylists || !Array.isArray(stylists)) {

        return;
    }

    // Находим селект стилистов
    const stylistSelect = document.querySelector('[data-select="stylist"]');
    if (!stylistSelect) {

        return;
    }

    // Очищаем существующие опции
    clearCustomSelectOptions(stylistSelect);

    // Добавляем стилистов из API (без placeholder опций)
    stylists.forEach(stylist => {
        if (stylist.active) { // Добавляем только активных стилистов
            addCustomSelectOption(stylistSelect, stylist.id, stylist.title);
        }
    });

    // Сохраняем данные стилистов в глобальную переменную для дальнейшего использования
    window.stylistsData = { results: stylists };

    // Триггерим событие, что селект стилистов заполнен
    if (stylistSelect) {
        // Небольшая задержка, чтобы DOM успел обновиться
        setTimeout(() => {
            const event = new CustomEvent('stylistsPopulated', {
                detail: { stylists: stylists },
                bubbles: true,
                cancelable: true
            });
            stylistSelect.dispatchEvent(event);
            console.log('Событие stylistsPopulated отправлено на элемент, добавлено стилистов:', stylists.length);

            // Также отправляем событие на document для глобального прослушивания
            document.dispatchEvent(new CustomEvent('stylistsPopulated', {
                detail: { stylists: stylists, element: stylistSelect }
            }));
            console.log('Событие stylistsPopulated также отправлено на document');
        }, 50);
    }

    // Если нет стилистов, добавляем тестовые данные с событиями
    if (stylists.length === 0) {

        const testStylists = [];

        testStylists.forEach(stylist => {
            addCustomSelectOption(stylistSelect, stylist.id, stylist.title);
        });

        window.stylistsData = { results: testStylists };

        // Триггерим событие и для тестовых данных
        if (stylistSelect) {
            stylistSelect.dispatchEvent(new CustomEvent('stylistsPopulated', {
                detail: { stylists: testStylists }
            }));
        }
    }
}

// Функция для получения доступных дат стилиста из events
// Функция для проверки, является ли дата прошедшей
function isDateInPast(dateString) {
    const today = new Date();
    // Используем локальное время устройства
    const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    return dateString < todayString;
}

// Функция для получения всех доступных дат из всех стилистов
function getAllAvailableDates() {
    if (!window.stylistsData || !window.stylistsData.results) {
        return [];
    }

    const allDates = new Set();

    // Проходим по всем стилистам
    window.stylistsData.results.forEach(stylist => {
        if (stylist.events && stylist.events.length > 0) {
            stylist.events.forEach(event => {
                // Парсим дату события и извлекаем только дату без времени
                const eventDate = new Date(event.start_date);
                const dateString = `${eventDate.getFullYear()}-${String(eventDate.getMonth() + 1).padStart(2, '0')}-${String(eventDate.getDate()).padStart(2, '0')}`;
                allDates.add(dateString);
            });
        }
    });

    // Фильтруем прошедшие даты
    const filteredDates = Array.from(allDates).filter(dateString => {
        return !isDateInPast(dateString);
    });

    const sortedDates = filteredDates.sort();
    return sortedDates;
}

// Функция для получения доступных дат конкретного стилиста (для обратной совместимости)
function getAvailableDatesFromEvents(stylistId) {
    if (!window.stylistsData || !window.stylistsData.results) {
        return [];
    }

    const stylist = window.stylistsData.results.find(s => s.id == stylistId);
    if (!stylist || !stylist.events || stylist.events.length === 0) {
        return [];
    }

    // Извлекаем уникальные даты из событий
    const uniqueDates = new Set();
    stylist.events.forEach(event => {
        // Парсим дату события и извлекаем только дату без времени
        const eventDate = new Date(event.start_date);
        const dateString = `${eventDate.getFullYear()}-${String(eventDate.getMonth() + 1).padStart(2, '0')}-${String(eventDate.getDate()).padStart(2, '0')}`;
        uniqueDates.add(dateString);
    });

    // Фильтруем прошедшие даты
    const filteredDates = Array.from(uniqueDates).filter(dateString => {
        return !isDateInPast(dateString);
    });

    const sortedDates = filteredDates.sort();
    return sortedDates;
}

// Функция для получения дат с доступным временем
function getDatesWithAvailableTime(stylistId) {
    if (!window.stylistsData || !window.stylistsData.results) {

        return [];
    }

    const stylist = window.stylistsData.results.find(s => s.id == stylistId);
    if (!stylist || !stylist.events || stylist.events.length === 0) {

        return [];
    }

    // Группируем события по датам и проверяем доступность
    const eventsByDate = {};
    stylist.events.forEach(event => {
        const eventDate = new Date(event.start_date);
        const dateString = `${eventDate.getFullYear()}-${String(eventDate.getMonth() + 1).padStart(2, '0')}-${String(eventDate.getDate()).padStart(2, '0')}`;

        if (!eventsByDate[dateString]) {
            eventsByDate[dateString] = [];
        }
        eventsByDate[dateString].push(event);
    });

    // Фильтруем только даты с доступным временем и исключаем прошедшие даты
    const availableDates = [];
    Object.keys(eventsByDate).forEach(dateString => {
        // Проверяем, не является ли дата прошедшей
        if (isDateInPast(dateString)) {
            return;
        }

        const dayEvents = eventsByDate[dateString];
        const availableEvents = dayEvents.filter(event => event.capacity > event.users_count);

        if (availableEvents.length > 0) {
            availableDates.push(dateString);
        }
    });

    const sortedDates = availableDates.sort();
    return sortedDates;
}

// Функция для управления состоянием поля времени
function updateTimeFieldState() {
    const timeSelect = document.querySelector('[data-select="time"]');
    const stylistSelect = document.querySelector('[data-select="stylist"]');
    const dateInput = document.querySelector('#shopping_date');

    if (!timeSelect) return;

    const stylistId = stylistSelect ? getCustomSelectValue(stylistSelect) : null;
    const selectedDate = dateInput ? dateInput.value : '';

    // Поле времени доступно только если выбраны и стилист, и дата
    const isTimeFieldEnabled = stylistId && selectedDate;

    if (isTimeFieldEnabled) {
        timeSelect.classList.remove('disabled');
        timeSelect.style.pointerEvents = 'auto';
        timeSelect.style.opacity = '1';

        // Если поле времени было отключено, но теперь должно быть включено,
        // и у нас есть выбранное время, восстанавливаем его
        const timeValue = document.querySelector('input[name="shopping_time"]').value;
        // Проверяем, что значение является временем (формат "HH:MM-HH:MM"), а не event_id
        const timePattern = /^\d{2}:\d{2}-\d{2}:\d{2}$/;
        const isValidTime = timeValue && timePattern.test(timeValue);

        if (isValidTime && !timeSelect.querySelector('.custom-select__options .custom-select__option[data-value="' + timeValue + '"]')) {
            // Время было выбрано, но опции были очищены - восстанавливаем опции
            populateTimeSelect(stylistId, selectedDate);
        } else if (timeValue && !isValidTime) {
            // Если значение не является временем (возможно, это старый event_id), очищаем поле
            const timeInput = document.querySelector('input[name="shopping_time"]');
            if (timeInput) {
                timeInput.value = '';
            }
        }
    } else {
        timeSelect.classList.add('disabled');
        timeSelect.style.pointerEvents = 'none';
        timeSelect.style.opacity = '0.5';
        // Очищаем селект времени только если нет выбранного времени
        const timeValue = document.querySelector('input[name="shopping_time"]').value;
        if (!timeValue) {
            clearCustomSelectOptions(timeSelect);
            // Очищаем event_id при отключении поля времени
            updateEventIdField();
        }
    }
}

// Функция для восстановления всех стилистов
function restoreAllStylists() {
    const stylistSelect = document.querySelector('[data-select="stylist"]');
    if (!stylistSelect || !window.stylistsData || !window.stylistsData.results) {
        return;
    }

    // Очищаем текущие опции
    clearCustomSelectOptions(stylistSelect);

    // Добавляем всех стилистов
    window.stylistsData.results.forEach(stylist => {
        addCustomSelectOption(stylistSelect, stylist.id, stylist.name);
    });
}

// Функция для восстановления всех стилистов с сохранением выбранного
function restoreAllStylistsWithSelection(selectedStylistId) {
    const stylistSelect = document.querySelector('[data-select="stylist"]');
    if (!stylistSelect || !window.stylistsData || !window.stylistsData.results) {
        return;
    }

    // Очищаем текущие опции
    clearCustomSelectOptions(stylistSelect);

    // Добавляем всех стилистов
    window.stylistsData.results.forEach(stylist => {
        addCustomSelectOption(stylistSelect, stylist.id, stylist.name);
    });

    // Восстанавливаем выбранного стилиста с небольшой задержкой
    if (selectedStylistId) {
        setTimeout(() => {
            setCustomSelectValue(stylistSelect, selectedStylistId);
        }, 10);
    }
}

// Функция для обновления календаря в зависимости от выбранного стилиста
function updateCalendarForStylist(stylistId) {
    const dateInput = document.querySelector('#shopping_date');
    const selectedDate = dateInput ? dateInput.value : '';

    if (selectedDate) {
        // Сценарий 1: Дата уже выбрана -> НЕ трогаем список стилистов, просто переключаем режим
        window.bookingMode = 'normal';
    } else {
        // Сценарий 2: Дата не выбрана -> показываем только даты выбранного стилиста
        window.bookingMode = 'stylist_selected';
    }

    // Обновляем календарь
    if (window.updateCustomCalendar) {
        window.updateCustomCalendar();
    }
}

// Функция для обновления datepicker с доступными датами
function updateDatepickerWithAvailableDates() {
    const dateInput = document.querySelector('#shopping_date');
    if (!dateInput) {
        return;
    }

    const availableDates = getAllAvailableDates();

    if (availableDates.length === 0) {
        // Очищаем поле даты
        dateInput.value = '';
        return;
    }

    // Обновляем календарь, если он открыт
    if (window.updateCustomCalendar) {
        window.updateCustomCalendar();
    }

    // Обновляем состояние поля времени
    updateTimeFieldState();
}

// Функция для заполнения селекта времени на основе выбранного стилиста
function populateTimeSelect(stylistId, selectedDate) {


    if (!stylistId || !selectedDate) {

        return;
    }

    // Проверяем, не является ли выбранная дата прошедшей
    let dateStringForCheck;
    if (selectedDate.includes('.')) {
        // Формат DD.MM.YYYY (от Air Datepicker)
        const [day, month, year] = selectedDate.split('.');
        dateStringForCheck = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    } else {
        // Формат YYYY-MM-DD (от HTML5 date input)
        dateStringForCheck = selectedDate;
    }

    if (isDateInPast(dateStringForCheck)) {

        // Очищаем селект времени
        const timeSelect = document.querySelector('[data-select="time"]');
        if (timeSelect) {
            clearCustomSelectOptions(timeSelect);
        }
        return;
    }

    // Находим селект времени
    const timeSelect = document.querySelector('[data-select="time"]');
    if (!timeSelect) {

        return;
    }



    // Сохраняем текущее выбранное время перед очисткой
    const currentTimeValue = document.querySelector('input[name="shopping_time"]').value;

    // Очищаем существующие опции
    clearCustomSelectOptions(timeSelect);

    // Получаем данные стилистов из глобальной переменной или делаем новый запрос
    if (window.stylistsData && window.stylistsData.results) {

        const stylist = window.stylistsData.results.find(s => s.id == stylistId);


        if (stylist && stylist.events && stylist.events.length > 0) {


            // Фильтруем события по выбранной дате
            let selectedDateObj;

            // Проверяем формат даты и конвертируем в нужный формат
            if (selectedDate.includes('.')) {
                // Формат DD.MM.YYYY (от Air Datepicker)
                const [day, month, year] = selectedDate.split('.');
                // Используем UTC для избежания проблем с часовым поясом
                selectedDateObj = new Date(Date.UTC(year, month - 1, day));
            } else {
                // Формат YYYY-MM-DD (от HTML5 date input)
                selectedDateObj = new Date(selectedDate + 'T00:00:00');
            }




            const stylistEvents = stylist.events.filter(event => {
                const eventDate = new Date(event.start_date);
                const eventDateStr = `${eventDate.getFullYear()}-${String(eventDate.getMonth() + 1).padStart(2, '0')}-${String(eventDate.getDate()).padStart(2, '0')}`;
                const selectedDateStr = `${selectedDateObj.getFullYear()}-${String(selectedDateObj.getMonth() + 1).padStart(2, '0')}-${String(selectedDateObj.getDate()).padStart(2, '0')}`;
                const isMatch = eventDateStr === selectedDateStr;

                return isMatch;
            });



            if (stylistEvents.length > 0) {
                // Сортируем события по времени начала
                stylistEvents.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));



                // Добавляем доступные временные слоты
                stylistEvents.forEach(event => {
                    const startTime = new Date(event.start_date);
                    const endTime = new Date(event.end_date);
                    const timeSlot = `${startTime.getHours().toString().padStart(2, '0')}:${startTime.getMinutes().toString().padStart(2, '0')}-${endTime.getHours().toString().padStart(2, '0')}:${endTime.getMinutes().toString().padStart(2, '0')}`;

                    // Добавляем информацию о доступности
                    const isAvailable = event.capacity > event.users_count;
                    const optionText = isAvailable ? timeSlot : `${timeSlot} (занято)`;
                    // Используем время в качестве значения опции, а не event_id
                    const optionValue = isAvailable ? timeSlot : '';

                    addCustomSelectOption(timeSelect, optionValue, optionText);
                });
            } else {

                // Если нет событий на эту дату, добавляем сообщение
                addCustomSelectOption(timeSelect, '', 'Нет доступного времени на эту дату');

                // Показываем предупреждение пользователю

            }
        } else {

            // Если у стилиста нет событий, добавляем стандартные слоты
            addStandardTimeSlots(timeSelect);
        }
    } else {

        // Если нет данных стилистов, добавляем стандартные слоты
        addStandardTimeSlots(timeSelect);
    }

    // Восстанавливаем ранее выбранное время, если оно было
    // Проверяем, что значение является временем (формат "HH:MM-HH:MM"), а не event_id
    if (currentTimeValue) {
        // Проверяем формат времени (должно быть "HH:MM-HH:MM", а не число)
        const timePattern = /^\d{2}:\d{2}-\d{2}:\d{2}$/;
        const isValidTime = timePattern.test(currentTimeValue);

        if (isValidTime) {
            // Небольшая задержка для того, чтобы опции успели добавиться в DOM
            setTimeout(() => {
                const timeInput = document.querySelector('input[name="shopping_time"]');
                if (timeInput) {
                    timeInput.value = currentTimeValue;
                    // Обновляем отображение в кастомном селекте
                    setCustomSelectValue(timeSelect, currentTimeValue);
                }
            }, 50);
        } else {
            // Если значение не является временем (возможно, это старый event_id), очищаем поле
            const timeInput = document.querySelector('input[name="shopping_time"]');
            if (timeInput) {
                timeInput.value = '';
            }
        }
    }
}

// Функция для добавления стандартных временных слотов
function addStandardTimeSlots(timeSelect) {
    const timeSlots = [
        '09:00-10:00',
        '10:00-11:00',
        '11:00-12:00',
        '12:00-13:00',
        '13:00-14:00',
        '14:00-15:00',
        '15:00-16:00',
        '16:00-17:00',
        '17:00-18:00',
        '18:00-19:00',
        '19:00-20:00',
        '20:00-21:00'
    ];

    timeSlots.forEach(timeSlot => {
        addCustomSelectOption(timeSelect, timeSlot, timeSlot);
    });
}

// Инициализация обработчиков событий для динамического обновления
function initShoppingFormHandlers() {
    //

    // Устанавливаем минимальную дату для HTML5 date input и очищаем автоматически установленную дату
    const dateInputElement = document.querySelector('#shopping_date');
    if (dateInputElement && dateInputElement.type === 'date') {
        const today = new Date();
        const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        dateInputElement.min = todayString;
        // Очищаем автоматически установленную дату
        dateInputElement.value = '';

        // Добавляем обработчик изменения даты
        dateInputElement.addEventListener('change', function() {
            updateTimeFieldState();

            const stylistSelect = document.querySelector('[data-select="stylist"]');
            const stylistId = stylistSelect ? getCustomSelectValue(stylistSelect) : null;

            if (stylistId && this.value) {
                // Конвертируем дату в формат DD.MM.YYYY для populateTimeSelect
                const date = new Date(this.value);
                const formattedDate = `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`;
                populateTimeSelect(stylistId, formattedDate);
            }

            // Обновляем event_id при изменении даты
            updateEventIdField();
        });
    }

    // Обработчик изменения стилиста
    document.addEventListener('change', function(e) {


        if (e.target.name === 'shopping_stylist') {
            const stylistId = e.target.value;


            if (stylistId) {


                // Обновляем фотографию стилиста
                updateStylistPhoto(stylistId);

                // Обновляем календарь в зависимости от сценария
                updateCalendarForStylist(stylistId);

                // Обновляем состояние поля времени
                updateTimeFieldState();

                // Проверяем, есть ли уже выбранная дата
                const dateInput = document.querySelector('#shopping_date');
                const selectedDate = dateInput ? dateInput.value : '';

                if (selectedDate) {
                    // Если дата уже выбрана, заполняем время для выбранного стилиста

                    window.bookingMode = 'normal'; // Переключаемся в обычный режим
                    populateTimeSelect(stylistId, selectedDate);
                } else {
                    // Если дата не выбрана, НЕ очищаем поле даты в альтернативном режиме

                    window.bookingMode = 'normal';
                }

                // Обновляем event_id при изменении стилиста
                updateEventIdField();

                // Добавляем обработчик для Air Datepicker при выборе даты
                if (false) { // Air Datepicker удален
                    // Удаляем старый обработчик если есть
                    if (dateInput._stylistChangeHandler) {
                        dateInput.removeEventListener('change', dateInput._stylistChangeHandler);
                    }

                    // Добавляем новый обработчик
                    dateInput._stylistChangeHandler = function(e) {

                        if (e.target.value) {
                            populateTimeSelect(stylistId, e.target.value);
                        }
                    };

                    dateInput.addEventListener('change', dateInput._stylistChangeHandler);


                    // Принудительно обновляем календарь с исключением дат без времени
                    setTimeout(() => {

                        updateDatepickerWithAvailableDates();
                    }, 100);
                }
            } else {
                // Если стилист не выбран, сбрасываем фотографию

                updateStylistPhoto(null);
            }
        }
    });

    // Обработчик изменения даты
    document.addEventListener('change', function(e) {


        if (e.target.id === 'shopping_date') {
            const selectedDate = e.target.value;
            const stylistSelect = document.querySelector('[data-select="stylist"]');
            const stylistId = stylistSelect ? getCustomSelectValue(stylistSelect) : null;



            if (stylistId && selectedDate) {
                // Обычный режим: заполняем время для выбранного стилиста

                window.bookingMode = 'normal';
                populateTimeSelect(stylistId, selectedDate);
            } else if (selectedDate && !stylistId) {
                // Альтернативный режим: фильтруем стилистов по дате




                window.bookingMode = 'alternative';

                // Конвертируем дату в формат YYYY-MM-DD для фильтрации

                const dateParts = selectedDate.split('.');


                if (dateParts.length === 3) {
                    const dateStr = `${dateParts[2]}-${dateParts[1].padStart(2, '0')}-${dateParts[0].padStart(2, '0')}`;

                    filterStylistsByDate(dateStr);
                } else {

                }

                // Очищаем селект времени
                const timeSelect = document.querySelector('[data-select="time"]');
                if (timeSelect) {
                    clearCustomSelectOptions(timeSelect);
                }

                // Обновляем календарь для подсветки выбранной даты
                setTimeout(() => {
                    if (typeof updateCalendar === 'function') {
                        updateCalendar();
                    }
                }, 100);
            } else if (!selectedDate) {
                // Если дата очищена - сбрасываем фильтрацию стилистов

                window.bookingMode = 'normal';
                if (window.stylistsData && window.stylistsData.results && Array.isArray(window.stylistsData.results)) {
                    populateStylistSelect(window.stylistsData.results);
                }
            }
        }
    });

    // Дополнительный обработчик для Air Datepicker - используем setTimeout для задержки
    document.addEventListener('change', function(e) {
        if (e.target.id === 'shopping_date') {

            setTimeout(() => {
            const selectedDate = e.target.value;
            const stylistSelect = document.querySelector('[data-select="stylist"]');
            const stylistId = stylistSelect ? getCustomSelectValue(stylistSelect) : null;

            if (stylistId && selectedDate) {

                populateTimeSelect(stylistId, selectedDate);
            }
            }, 100); // Небольшая задержка для корректной работы
        }
    });

    // Дополнительный обработчик для Air Datepicker
    document.addEventListener('input', function(e) {
        if (e.target.id === 'shopping_date') {

            const selectedDate = e.target.value;
            const stylistSelect = document.querySelector('[data-select="stylist"]');
            const stylistId = stylistSelect ? getCustomSelectValue(stylistSelect) : null;

            if (stylistId && selectedDate) {

                populateTimeSelect(stylistId, selectedDate);
            }
        }
    });

    // Обработчик для отслеживания изменений в поле даты
    const dateInput = document.querySelector('#shopping_date');
    if (dateInput) {
        // Используем MutationObserver для отслеживания изменений
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                    const selectedDate = dateInput.value;
                    const stylistSelect = document.querySelector('[data-select="stylist"]');
                    const stylistId = stylistSelect ? getCustomSelectValue(stylistSelect) : null;



                    if (stylistId && selectedDate) {

                        populateTimeSelect(stylistId, selectedDate);
                    }
                }
            });
        });

        observer.observe(dateInput, { attributes: true, attributeFilter: ['value'] });


        // Добавляем обработчик клика для принудительной проверки
        dateInput.addEventListener('click', function() {
            setTimeout(() => {
                const selectedDate = dateInput.value;
const stylistSelect = document.querySelector('[data-select="stylist"]');
                const stylistId = stylistSelect ? getCustomSelectValue(stylistSelect) : null;

                if (stylistId && selectedDate) {
                    populateTimeSelect(stylistId, selectedDate);
                }
            }, 100);
        });

        // Добавляем обработчик фокуса
        dateInput.addEventListener('focus', function() {
            setTimeout(() => {
                const selectedDate = dateInput.value;
                const stylistSelect = document.querySelector('[data-select="stylist"]');
                const stylistId = stylistSelect ? getCustomSelectValue(stylistSelect) : null;

                if (stylistId && selectedDate) {
                    populateTimeSelect(stylistId, selectedDate);
                }
            }, 100);
        });
    }

    // Добавляем обработчик изменения времени
    document.addEventListener('change', function(e) {
        if (e.target.name === 'shopping_time') {
            // Обновляем event_id при изменении времени
            updateEventIdField();
        }
    });

}


// Функция для инициализации всей системы бронирования
function initBookingSystem() {
    // Проверяем, не инициализирована ли уже система
    if (window.bookingSystemInitialized) {
        return;
    }

    // Очищаем поле даты при инициализации системы
    const dateInput = document.querySelector('#shopping_date');
    if (dateInput) {
        dateInput.value = '';
    }

    // Очищаем поле времени, если там некорректное значение (например, старый event_id)
    const timeInput = document.querySelector('input[name="shopping_time"]');
    if (timeInput) {
        const timeValue = timeInput.value;
        const timePattern = /^\d{2}:\d{2}-\d{2}:\d{2}$/;
        // Если значение не является временем (возможно, это старый event_id), очищаем поле
        if (timeValue && !timePattern.test(timeValue)) {
            timeInput.value = '';
        }
    }

    // Устанавливаем начальное состояние поля времени
    updateTimeFieldState();

    // Инициализируем режим работы
    window.bookingMode = 'alternative';

    // Инициализируем кастомные селекты
    initCustomSelects();

    // Инициализируем кастомный календарь
    initCustomCalendarNew();

    // Инициализируем обработчики событий
    initShoppingFormHandlers();

    // Помечаем систему как инициализированную
    window.bookingSystemInitialized = true;
}

// Функции для управления состоянием загрузки
function showLoadingState() {
    // Ищем контейнер виджета более точно
    const bookingForm = document.querySelector('.shopping-form, .booking-form, .widget-container, .book-stylist, [data-widget="booking"]') ||
                       document.querySelector('form') ||
                       document.body;
    if (!bookingForm) return;

    // Создаем прелоадер
    const loader = document.createElement('div');
    loader.className = 'booking-loader';
    loader.innerHTML = `
        <div class="loader-content">
            <div class="loader-spinner"></div>
            <p>Загрузка данных...</p>
        </div>
    `;

    // Добавляем стили для прелоадера
    loader.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
    `;

    bookingForm.style.position = 'relative';
    bookingForm.appendChild(loader);
}

function hideLoadingState() {
    const loader = document.querySelector('.booking-loader');
    if (loader) {
        loader.remove();
    }
}

function showErrorState(errorMessage = 'Ошибка загрузки данных') {
    // Ищем контейнер виджета более точно
    const bookingForm = document.querySelector('.shopping-form, .booking-form, .widget-container, .book-stylist, [data-widget="booking"]') ||
                       document.querySelector('form') ||
                       document.body;
    if (!bookingForm) return;

    // Создаем сообщение об ошибке
    const errorDiv = document.createElement('div');
    errorDiv.className = 'booking-error';
    errorDiv.innerHTML = `
        <div class="error-content">
            <div class="error-icon">⚠️</div>
            <p>${errorMessage}</p>
            <button class="retry-button" onclick="retryLoadingData()">Повторить</button>
        </div>
    `;

    // Добавляем стили для ошибки
    errorDiv.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.95);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
    `;

    bookingForm.style.position = 'relative';
    bookingForm.appendChild(errorDiv);
}

function hideErrorState() {
    const errorDiv = document.querySelector('.booking-error');
    if (errorDiv) {
        errorDiv.remove();
    }
}

// Функция для повторной загрузки данных
function retryLoadingData() {
    hideErrorState();
    showLoadingState();
    // Сбрасываем флаг загрузки для повторной попытки
    window.stylistsDataLoading = false;
    // Перезагружаем страницу для повторной попытки загрузки данных
    window.location.reload();
}

// Функция для получения event_id на основе выбранной даты и времени
function getEventId(stylistId, selectedDate, selectedTime) {
    if (!stylistId || !selectedDate || !selectedTime || !window.stylistsData || !window.stylistsData.results) {
        return null;
    }

    const stylist = window.stylistsData.results.find(s => s.id == stylistId);
    if (!stylist || !stylist.events || stylist.events.length === 0) {
        return null;
    }

    // Конвертируем выбранную дату в нужный формат
    let selectedDateObj;
    if (selectedDate.includes('.')) {
        // Формат DD.MM.YYYY (от Air Datepicker)
        const [day, month, year] = selectedDate.split('.');
        selectedDateObj = new Date(Date.UTC(year, month - 1, day));
    } else {
        // Формат YYYY-MM-DD (от HTML5 date input)
        selectedDateObj = new Date(selectedDate + 'T00:00:00');
    }

    // Фильтруем события по выбранной дате
    const stylistEvents = stylist.events.filter(event => {
        const eventDate = new Date(event.start_date);
        const eventDateStr = `${eventDate.getFullYear()}-${String(eventDate.getMonth() + 1).padStart(2, '0')}-${String(eventDate.getDate()).padStart(2, '0')}`;
        const selectedDateStr = `${selectedDateObj.getFullYear()}-${String(selectedDateObj.getMonth() + 1).padStart(2, '0')}-${String(selectedDateObj.getDate()).padStart(2, '0')}`;
        return eventDateStr === selectedDateStr;
    });

    // Ищем событие по времени (так как в populateTimeSelect мы сохраняем timeSlot в качестве значения)
    const matchingEvent = stylistEvents.find(event => {
        const startTime = new Date(event.start_date);
        const endTime = new Date(event.end_date);
        const eventTimeSlot = `${startTime.getHours().toString().padStart(2, '0')}:${startTime.getMinutes().toString().padStart(2, '0')}-${endTime.getHours().toString().padStart(2, '0')}:${endTime.getMinutes().toString().padStart(2, '0')}`;
        return eventTimeSlot === selectedTime;
    });

    return matchingEvent ? matchingEvent.id : null;
}

// Функция для обновления скрытого поля с event_id
function updateEventIdField() {
    const stylistSelect = document.querySelector('[data-select="stylist"]');
    const dateInput = document.querySelector('#shopping_date');
    const timeSelect = document.querySelector('[data-select="time"]');
    const eventIdField = document.querySelector('input[name="event_id"]');

    if (!stylistSelect || !dateInput || !timeSelect || !eventIdField) {
        return;
    }

    const stylistId = getCustomSelectValue(stylistSelect);
    const selectedDate = dateInput.value;
    const selectedTime = getCustomSelectValue(timeSelect);

    if (stylistId && selectedDate && selectedTime) {
        const eventId = getEventId(stylistId, selectedDate, selectedTime);
        eventIdField.value = eventId || '';
    } else {
        eventIdField.value = '';
    }
}


// Функция для загрузки данных стилистов
// Функция loadStylistsData удалена - теперь загрузка происходит через реальный API в main.js

// Функция для принудительного обновления времени
function forceUpdateTime() {
                const stylistSelect = document.querySelector('[data-select="stylist"]');
    const dateInput = document.querySelector('#shopping_date');
    const stylistId = stylistSelect ? getCustomSelectValue(stylistSelect) : null;
    const selectedDate = dateInput ? dateInput.value : null;



    if (stylistId && selectedDate) {
        populateTimeSelect(stylistId, selectedDate);
    } else {

    }
}

// Функция для принудительного обновления календаря с исключением дат без времени
function forceUpdateCalendar() {
                const stylistSelect = document.querySelector('[data-select="stylist"]');
    const stylistId = stylistSelect ? getCustomSelectValue(stylistSelect) : null;

    if (stylistId) {

        updateDatepickerWithAvailableDates();
    } else {

    }
}

// Функция для проверки всех дат стилиста на доступность времени
function checkAllDatesAvailability(stylistId) {
    if (!window.stylistsData || !window.stylistsData.results) {

        return;
    }

    const stylist = window.stylistsData.results.find(s => s.id == stylistId);
    if (!stylist || !stylist.events || stylist.events.length === 0) {

        return;
    }



    // Группируем события по датам
    const eventsByDate = {};
    stylist.events.forEach(event => {
        const eventDate = new Date(event.start_date);
        const dateString = `${eventDate.getFullYear()}-${String(eventDate.getMonth() + 1).padStart(2, '0')}-${String(eventDate.getDate()).padStart(2, '0')}`;

        if (!eventsByDate[dateString]) {
            eventsByDate[dateString] = [];
        }
        eventsByDate[dateString].push(event);
    });

    // Проверяем каждую дату
    Object.keys(eventsByDate).forEach(dateString => {
        const dayEvents = eventsByDate[dateString];
        const availableEvents = dayEvents.filter(event => event.capacity > event.users_count);
    });


}

// Функция для тестирования исключения дат
function testDateExclusion() {


    // Выбираем стилиста
    setCustomSelectValue(document.querySelector('[data-select="stylist"]'), '150');

    // Проверяем доступность всех дат
    checkAllDatesAvailability('150');

    // Принудительно обновляем календарь
    forceUpdateCalendar();


}

// Функция для тестирования выбора конкретной даты
function testSelectDate(dateString) {


    const dateInput = document.querySelector('#shopping_date');
    if (dateInput) {
        dateInput.value = dateString;
        dateInput.dispatchEvent(new Event('change', { bubbles: true }));

    } else {

    }
}

// Функция для тестирования блокировки недоступных дат
function testDateBlocking() {


    // Выбираем стилиста
    setCustomSelectValue(document.querySelector('[data-select="stylist"]'), '150');

    // Проверяем доступные даты
    const availableDates = getAvailableDatesFromEvents('150');


    // Пытаемся выбрать недоступную дату

    const dateInput = document.querySelector('#shopping_date');
    // Тест для кастомного календаря


    // Пытаемся выбрать доступную дату




}

// Функция для тестирования альтернативного режима фильтрации
function testAlternativeMode() {


    // Проверяем, что данные стилистов загружены
    if (!window.stylistsData || !window.stylistsData.results) {

        return;
    }



    // Тестируем фильтрацию по дате 2025-10-08 (должна найти стилистов)

    filterStylistsByDate('2025-10-08');

    // Тестируем фильтрацию по дате 2025-10-10 (не должно найти стилистов)
    setTimeout(() => {

        filterStylistsByDate('2025-10-10');
    }, 1000);

    // Тестируем фильтрацию по дате 2025-10-15 (должна найти стилистов)
    setTimeout(() => {

        filterStylistsByDate('2025-10-15');
    }, 2000);


}

// Функция для тестирования переключения между режимами
function testModeSwitching() {


    // Проверяем, что данные стилистов загружены
    if (!window.stylistsData || !window.stylistsData.results) {

        return;
    }



    // Шаг 1: Выбираем дату без стилиста (альтернативный режим)

    const dateInput = document.querySelector('#shopping_date');
    if (dateInput) {
        dateInput.value = '08.10.2025';
        dateInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Шаг 2: Выбираем стилиста (переключение в обычный режим)
    setTimeout(() => {

        const stylistSelect = document.querySelector('[data-select="stylist"]');
        if (stylistSelect) {
            setCustomSelectValue(stylistSelect, '1');
            // Триггерим событие change
            const hiddenInput = stylistSelect.querySelector('input[type="hidden"]');
            if (hiddenInput) {
                hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }, 1000);

    // Шаг 3: Проверяем, что время заполнилось
    setTimeout(() => {

        const timeSelect = document.querySelector('[data-select="time"]');
        if (timeSelect) {
            const timeOptions = timeSelect.querySelectorAll('.custom-select__option');

        }
    }, 2000);


}

// Функция для тестирования селектов без placeholder опций
function testSelectorsWithoutPlaceholders() {


    // Проверяем селект стилистов
    const stylistSelect = document.querySelector('[data-select="stylist"]');
    if (stylistSelect) {
        const stylistOptions = stylistSelect.querySelectorAll('.custom-select__option');


        // Проверяем, что нет placeholder опций
        const hasPlaceholder = Array.from(stylistOptions).some(option =>
            option.textContent.includes('Выберите') ||
            option.textContent.includes('Сначала')
        );

    }

    // Проверяем селект времени
    const timeSelect = document.querySelector('[data-select="time"]');
    if (timeSelect) {
        const timeOptions = timeSelect.querySelectorAll('.custom-select__option');


        // Проверяем, что нет placeholder опций
        const hasPlaceholder = Array.from(timeOptions).some(option =>
            option.textContent.includes('Выберите') ||
            option.textContent.includes('Сначала')
        );

    }


}

// Функция для тестирования плейсхолдеров в селектах
function testPlaceholders() {


    // Проверяем селект стилистов
    const stylistSelect = document.querySelector('[data-select="stylist"]');
    if (stylistSelect) {
        const valueSpan = stylistSelect.querySelector('.custom-select__value');


        // Проверяем, что нет placeholder опций в списке
        const stylistOptions = stylistSelect.querySelectorAll('.custom-select__option');
        const hasPlaceholderOption = Array.from(stylistOptions).some(option =>
            option.textContent.includes('Выберите') ||
            option.textContent.includes('Сначала')
        );

    }

    // Проверяем селект времени
    const timeSelect = document.querySelector('[data-select="time"]');
    if (timeSelect) {
        const valueSpan = timeSelect.querySelector('.custom-select__value');


        // Проверяем, что нет placeholder опций в списке
        const timeOptions = timeSelect.querySelectorAll('.custom-select__option');
        const hasPlaceholderOption = Array.from(timeOptions).some(option =>
            option.textContent.includes('Выберите') ||
            option.textContent.includes('Сначала')
        );

    }


}

// Функция для тестирования системы бронирования в home.php
function testHomeBooking() {


    // Проверяем наличие элементов формы
    const stylistSelect = document.querySelector('[data-select="stylist"]');
    const dateInput = document.querySelector('#shopping_date');
    const timeSelect = document.querySelector('[data-select="time"]');






    // Проверяем тип поля даты
    if (dateInput) {


    }

    // Проверяем инициализацию системы



    // Проверяем режим работы


    // Тестируем альтернативный режим
    if (dateInput && stylistSelect) {


        // Очищаем селект стилистов
        if (stylistSelect) {
            clearCustomSelectOptions(stylistSelect);
        }

        // Выбираем дату без стилиста
        dateInput.value = '08.10.2025';
        dateInput.dispatchEvent(new Event('change', { bubbles: true }));

        setTimeout(() => {



        }, 500);
    }


}

// Функция для тестирования смены фотографии стилиста
function testStylistPhotoUpdate() {


    // Проверяем наличие элемента фотографии
    const photoElement = document.getElementById('stylist-photo');


    if (photoElement) {


    }

    // Проверяем данные стилистов


    if (window.stylistsData && window.stylistsData.results) {


        // Показываем информацию о фотографиях стилистов
        window.stylistsData.results.forEach(stylist => {
            const photo = stylist.options && stylist.options.photo ? stylist.options.photo : 'не указана';

        });
    }

    // Тестируем смену фотографии


    // Выбираем первого стилиста
    if (window.stylistsData && window.stylistsData.results.length > 0) {
        const firstStylist = window.stylistsData.results[0];

        updateStylistPhoto(firstStylist.id);

        setTimeout(() => {



        }, 100);
    }


}

// Функция для тестирования разных типов фотографий
function testPhotoTypes() {


    const photoElement = document.getElementById('stylist-photo');
    if (!photoElement) {

        return;
    }

    // Тестируем строку

    updateStylistPhoto(1);

    setTimeout(() => {


        // Тестируем объект с url

        if (window.stylistsData && window.stylistsData.results.length > 0) {
            const stylist = window.stylistsData.results[0];
            stylist.options.photo = { url: '/wp-content/themes/planetalook/assets/images/teststylist.png' };
            updateStylistPhoto(1);

            setTimeout(() => {


                // Тестируем объект с src

                stylist.options.photo = { src: '/wp-content/themes/planetalook/assets/images/teststylist.png' };
                updateStylistPhoto(1);

                setTimeout(() => {


                    // Тестируем невалидный объект

                    stylist.options.photo = { invalid: 'data' };
                    updateStylistPhoto(1);

                    setTimeout(() => {


                    }, 100);
                }, 100);
            }, 100);
        }
    }, 100);
}

// Функция для тестирования исправления дублирования календаря
function testCalendarDuplication() {


    // Проверяем состояние инициализации


    const dateInput = document.querySelector('#shopping_date');
    if (dateInput) {


    }

    // Проверяем количество календарей на странице
    const calendarContainers = document.querySelectorAll('.custom-calendar-container');


    if (calendarContainers.length > 1) {

        calendarContainers.forEach((container, index) => {

        });
    } else if (calendarContainers.length === 1) {

    } else {

    }

    // Тестируем повторную инициализацию


    // Пытаемся инициализировать систему повторно
    if (typeof initBookingSystem === 'function') {

        initBookingSystem();

        setTimeout(() => {
            const newCalendarContainers = document.querySelectorAll('.custom-calendar-container');


            if (newCalendarContainers.length === calendarContainers.length) {

            } else {

            }
        }, 100);
    }


}

// Функция для тестирования исправления подсветки даты
function testDateHighlighting() {


    const dateInput = document.querySelector('#shopping_date');
    if (!dateInput) {

        return;
    }

    // Проверяем текущее состояние


    // Проверяем календарь
    const calendarContainer = document.querySelector('.custom-calendar-container');
    if (!calendarContainer) {

        return;
    }

    // Проверяем классы дат
    const todayElements = calendarContainer.querySelectorAll('.calendar-day.today');
    const selectedElements = calendarContainer.querySelectorAll('.calendar-day.selected');




    // Тестируем выбор даты в правильном формате


    // Выбираем дату в формате DD.MM.YYYY
    const testDate = '15.10.2025';
    dateInput.value = testDate;
    dateInput.dispatchEvent(new Event('change', { bubbles: true }));

    setTimeout(() => {



        // Обновляем календарь
        if (typeof updateCalendar === 'function') {
            updateCalendar();
        }

        setTimeout(() => {
            const newSelectedElements = calendarContainer.querySelectorAll('.calendar-day.selected');


            if (newSelectedElements.length > 0) {

                newSelectedElements.forEach((element, index) => {

                });
            } else {

            }
        }, 200);
    }, 200);


}

// Функция для принудительного обновления системы бронирования
function forceRefreshBookingSystem() {


    // Сбрасываем флаги инициализации
    window.bookingSystemInitialized = false;

    // Сбрасываем флаг календаря
    const dateInput = document.querySelector('#shopping_date');
    if (dateInput) {
        dateInput.dataset.calendarInitialized = 'false';
    }

    // Очищаем календарь
    const calendarContainer = document.querySelector('.custom-calendar-container');
    if (calendarContainer) {
        calendarContainer.remove();
    }

    // Переинициализируем систему
    setTimeout(() => {

        initBookingSystem();
    }, 100);


}

// Добавляем функции в глобальную область видимости
window.forceUpdateTime = forceUpdateTime;
window.forceUpdateCalendar = forceUpdateCalendar;
window.checkAllDatesAvailability = checkAllDatesAvailability;
window.testDateExclusion = testDateExclusion;
window.testSelectDate = testSelectDate;
window.testDateBlocking = testDateBlocking;
window.testAlternativeMode = testAlternativeMode;
window.testModeSwitching = testModeSwitching;
window.testSelectorsWithoutPlaceholders = testSelectorsWithoutPlaceholders;
window.testPlaceholders = testPlaceholders;
window.testHomeBooking = testHomeBooking;
window.updateStylistPhoto = updateStylistPhoto;
window.testStylistPhotoUpdate = testStylistPhotoUpdate;
window.testPhotoTypes = testPhotoTypes;
window.testCalendarDuplication = testCalendarDuplication;
window.testDateHighlighting = testDateHighlighting;
window.forceRefreshBookingSystem = forceRefreshBookingSystem;

// Глобальная переменная для отслеживания режима работы
window.bookingMode = 'normal'; // 'normal' или 'alternative'


// Глобальная функция для фильтрации стилистов по дате (альтернативный режим)
function filterStylistsByDate(selectedDate) {
    // Проверяем, не является ли выбранная дата прошедшей
    if (isDateInPast(selectedDate)) {
        // Очищаем селект стилистов
        const stylistSelect = document.querySelector('[data-select="stylist"]');
        if (stylistSelect) {
            clearCustomSelectOptions(stylistSelect);
        }
        return;
    }

    // Проверяем наличие данных стилистов
    if (!window.stylistsData || !window.stylistsData.results || !Array.isArray(window.stylistsData.results)) {


        // Ждем загрузки данных с интервалом проверки
        const checkDataInterval = setInterval(() => {
            if (window.stylistsData && window.stylistsData.results && Array.isArray(window.stylistsData.results)) {

                clearInterval(checkDataInterval);
                filterStylistsByDate(selectedDate); // Рекурсивный вызов после загрузки
            }
        }, 100);

        // Таймаут на случай, если данные так и не загрузятся
        setTimeout(() => {
            clearInterval(checkDataInterval);

        }, 5000);

        return;
    }

    const stylists = window.stylistsData.results;
    const availableStylists = stylists.filter(stylist => {
        if (!stylist.events || !Array.isArray(stylist.events)) {
            return false;
        }

        // Проверяем, есть ли события на выбранную дату
        const hasEventOnDate = stylist.events.some(event => {
            const eventDate = new Date(event.start_date);
            const eventDateStr = `${eventDate.getFullYear()}-${String(eventDate.getMonth() + 1).padStart(2, '0')}-${String(eventDate.getDate()).padStart(2, '0')}`;
            return eventDateStr === selectedDate;
        });

        return hasEventOnDate;
    });

    // Обновляем селект стилистов
    const stylistSelect = document.querySelector('[data-select="stylist"]');
    if (stylistSelect) {
        // Очищаем текущие опции
        clearCustomSelectOptions(stylistSelect);

        // Добавляем доступных стилистов
        availableStylists.forEach(stylist => {
            addCustomSelectOption(stylistSelect, stylist.id, stylist.title);
        });
    }
}

// Новая функция кастомного календаря
function initCustomCalendarNew() {
    const dateInput = document.querySelector('#shopping_date');
    if (!dateInput) {

        return;
    }

    // Проверяем, не инициализирован ли уже календарь
    if (dateInput.dataset.calendarInitialized === 'true') {

        return;
    }

    // Создаем контейнер для календаря
    const calendarContainer = document.createElement('div');
    calendarContainer.className = 'custom-calendar-container';

    // Вставляем календарь после поля ввода
    dateInput.parentNode.style.position = 'relative';
    dateInput.parentNode.appendChild(calendarContainer);

    // Убеждаемся, что поле даты пустое при инициализации
    if (dateInput.value) {
        dateInput.value = '';

    }

    // Переменные для отслеживания текущего месяца и года
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth();


    // Создаем календарь
    function createCalendar(year, month) {
        const today = new Date();
        const calendarYear = year !== undefined ? year : today.getFullYear();
        const calendarMonth = month !== undefined ? month : today.getMonth();

        const firstDay = new Date(calendarYear, calendarMonth, 1);
        const lastDay = new Date(calendarYear, calendarMonth + 1, 0);
        const daysInMonth = lastDay.getDate();
        const startDay = firstDay.getDay() === 0 ? 7 : firstDay.getDay(); // Понедельник = 1

        let calendarHTML = `
            <div class="custom-calendar">
                <div class="calendar-header">
                    <button type="button" class="prev-month"><svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 19.5L1.5 10.5L9.5 1.5" stroke="#121212" stroke-linecap="square"/>
</svg></button>
                    <h3>${getMonthName(calendarMonth)} ${calendarYear}</h3>
                    <button type="button" class="next-month"><svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 19.5L9.5 10.5L1.5 1.5" stroke="#121212" stroke-linecap="square" />
</svg></button>
                </div>
                <div class="calendar-weekdays">
                    <div>Пн</div><div>Вт</div><div>Ср</div><div>Чт</div><div>Пт</div><div>Сб</div><div>Вс</div>
                </div>
                <div class="calendar-days">
        `;

        // Добавляем пустые ячейки для начала месяца
        for (let i = 1; i < startDay; i++) {
            calendarHTML += '<div class="calendar-day empty"></div>';
        }

        // Добавляем дни месяца
        for (let day = 1; day <= daysInMonth; day++) {
            const dateStr = `${calendarYear}-${String(calendarMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            const isAvailable = isDateAvailable(dateStr);
            const isToday = day === today.getDate() && calendarMonth === today.getMonth() && calendarYear === today.getFullYear();

            // Проверяем, выбрана ли эта дата
            const dateInput = document.querySelector('#shopping_date');
            const selectedDate = dateInput ? dateInput.value : '';

            // Конвертируем выбранную дату в формат YYYY-MM-DD для сравнения
            let isSelected = false;
            if (selectedDate) {
                let selectedDateStr = '';
                if (selectedDate.includes('.')) {
                    // Формат DD.MM.YYYY (от Air Datepicker)
                    const [day, month, year] = selectedDate.split('.');
                    selectedDateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                } else {
                    // Формат YYYY-MM-DD
                    selectedDateStr = selectedDate;
                }
                isSelected = selectedDateStr === dateStr;
            }

            let dayClass = 'calendar-day';
            if (!isAvailable) dayClass += ' unavailable';
            if (isToday && !isSelected) dayClass += ' today'; // Показываем today только если дата не выбрана
            if (isSelected) dayClass += ' selected';

            calendarHTML += `
                <div class="${dayClass}" data-date="${dateStr}" data-day="${day}">
                    ${day}
                </div>
            `;
        }

        calendarHTML += '</div></div>';
        return calendarHTML;
    }

    // Проверяем доступность даты
    function isDateAvailable(dateStr) {
        // Сначала проверяем, не является ли дата прошедшей
        if (isDateInPast(dateStr)) {
            return false;
        }

        const stylistSelect = document.querySelector('[data-select="stylist"]');
        const stylistId = stylistSelect ? getCustomSelectValue(stylistSelect) : null;
        const dateInput = document.querySelector('#shopping_date');
        const selectedDate = dateInput ? dateInput.value : '';

        // Если стилист выбран, показываем только его даты
        if (stylistId) {
            const availableDates = getAvailableDatesFromEvents(stylistId);
            return availableDates.includes(dateStr);
        } else {
            // Если стилист не выбран, показываем все доступные даты
            const availableDates = getAllAvailableDates();
            return availableDates.includes(dateStr);
        }
    }

    // Получаем название месяца
    function getMonthName(month) {
        const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
                       'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
        return months[month];
    }


    // Показываем календарь
    function showCalendar() {
        calendarContainer.style.display = 'block';
        updateCalendar();
    }

    // Скрываем календарь
    function hideCalendar() {
        calendarContainer.style.display = 'none';
    }

    // Обновляем календарь
    function updateCalendar() {
        calendarContainer.innerHTML = createCalendar(currentYear, currentMonth);

        // Добавляем обработчики событий
        addCalendarEventListeners();
    }

    // Добавляем обработчики событий
    function addCalendarEventListeners() {
        // Клик по дню
        calendarContainer.addEventListener('click', function(e) {
            e.stopPropagation(); // Предотвращаем закрытие календаря
            const dayElement = e.target.closest('.calendar-day');
            if (dayElement && !dayElement.classList.contains('unavailable') && !dayElement.classList.contains('empty')) {
                const dateStr = dayElement.dataset.date;
                const day = dayElement.dataset.day;

                // Дополнительная проверка на прошедшие даты
                if (isDateInPast(dateStr)) {
                    return; // Блокируем выбор прошедшей даты
                }

                // Форматируем дату для поля ввода (DD.MM.YYYY)
                const date = new Date(dateStr);
                const formattedDate = `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`;

                dateInput.value = formattedDate;
                hideCalendar();

                // Проверяем режим работы календаря
                const stylistSelect = document.querySelector('[data-select="stylist"]');
                const stylistId = stylistSelect ? getCustomSelectValue(stylistSelect) : null;

                // Обновляем состояние поля времени
                updateTimeFieldState();

                if (!stylistId) {
                    // Альтернативный режим: фильтруем стилистов по дате
                    window.bookingMode = 'alternative';
                    filterStylistsByDate(dateStr);
                } else {
                    // Обычный режим: заполняем время для выбранного стилиста
                    window.bookingMode = 'normal';
                    populateTimeSelect(stylistId, formattedDate);
                }

                // Триггерим событие change
                const event = new Event('change', { bubbles: true });
                dateInput.dispatchEvent(event);

                // Обновляем event_id при выборе даты в календаре
                updateEventIdField();

                // Дата выбрана
            }
        });

        // Навигация по месяцам
        const prevBtn = calendarContainer.querySelector('.prev-month');
        const nextBtn = calendarContainer.querySelector('.next-month');

        if (prevBtn) {
            prevBtn.addEventListener('click', function(e) {
                e.stopPropagation(); // Предотвращаем закрытие календаря

                // Обновляем отслеживаемые переменные
                currentMonth--;
                if (currentMonth < 0) {
                    currentMonth = 11;
                    currentYear--;
                }

                calendarContainer.innerHTML = createCalendar(currentYear, currentMonth);
                addCalendarEventListeners();
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', function(e) {
                e.stopPropagation(); // Предотвращаем закрытие календаря

                // Обновляем отслеживаемые переменные
                currentMonth++;
                if (currentMonth > 11) {
                    currentMonth = 0;
                    currentYear++;
                }

                calendarContainer.innerHTML = createCalendar(currentYear, currentMonth);
                addCalendarEventListeners();
            });
        }
    }

    // Показываем календарь при клике на поле
    dateInput.addEventListener('click', function(e) {
        e.stopPropagation();
        showCalendar();
    });

    // Скрываем календарь при клике вне поля ввода и календаря
    document.addEventListener('click', function(e) {
        if (!dateInput.contains(e.target) && !calendarContainer.contains(e.target)) {
            hideCalendar();
        }
    });

    // Глобальная функция для обновления календаря
    window.updateCustomCalendar = function() {
        if (calendarContainer.style.display === 'block') {
            updateCalendar();
        }
    };


    // Помечаем календарь как инициализированный
    dateInput.dataset.calendarInitialized = 'true';


}
